<div class="card">
  <div class="card-title">
    <h2>EDITAR PERFIL</h2>
  </div>

  <div class="container-profile">
    <div class="content">
      <img id="avatar" [src]="imgURL ? imgURL : 'assets/img/profile.png'" alt="Avatar" class="image">
      <div class="middle">
        <span style="color: red" *ngIf="message">{{ message }}</span>
        <div class="upload-btn-wrapper">
          <button class="btn">foto</button>
          <input class="photo" type="file" accept="image/*" (change)="fileChangeEvent($event)" />
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="imageChangedEvent">
    <div class="d-flex justify-content-center" style="margin: 10px 0;">
      <button type="button" class="btn btn-info" (click)="uploadImage()">Upload da imagem</button>
    </div>
    <div class="row">
      <div class="text-center col-md-8">
        <h5>Cortar Imagem</h5>
        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
          [resizeToWidth]="256" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
      </div>
      <div class="text-center col-md-4">
        <h5>Previsualização</h5>
        <img [src]="croppedImage" />
      </div>
    </div>
  </ng-container>

  <div class="data" id="data" *ngFor="let item of profile">
    <div class="col-12">
      <div class="text-center">
        <div class="form-inline" [formGroup]="userFormNameGroup" style="display: flex; justify-content: center;">
          <div class="form-group mt-3">
            <label class="mr-2 profile-name">{{ item.name }}</label>
            <input #nameInput formControlName="name" class="form-control check-input mr-2" type="text"
              placeholder="Nome" style="display: none;" />
          </div>
          <button #btnChangeName type="button" class="button-alter" (click)="showInputName(btnChangeName, nameInput)"
            *ngIf="nameUpdated">
            Alterar
          </button>
          <button #btnSubmitName type="button" class="button-saved" (click)="submitName()"
            style="display: none;">
            Salvar
          </button>
        </div>
        <label class="col-lg-12 col-form-label form-control-label"> {{ item.email }} </label>
      </div>
      <div class="col-md-12 mb-3">
        <label class="col-form-label form-control-label">Email</label>
        <div class="col-md-4">
          <input class="form-control check-input" type="email" value="{{ item.email }}" disabled />
        </div>
      </div>
      <div class="col text-center">
        <button type="button" class="btn btn-outline-primary mb-2 mr-2" (click)="openProfileModal()">
          Informações Adicionais
        </button>
      </div>
    </div>

    <div class="jumbotron mt-4 mb-0">
      <form role="form" class="form" [formGroup]="userFormGroup">
        <h5 class="mb-4">Clique em editar para trocar sua senha</h5>
        <div class="form-group">
          <label class="col-form-label form-control-label">Senha Atual</label>
          <div>
            <input class="form-control check-input" type="password" formControlName="currentPassword"
              placeholder="Senha Atual" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-form-label form-control-label">Nova Senha</label>
          <div>
            <input class="form-control check-input" type="password" formControlName="password"
              placeholder="Nova Senha" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-form-label form-control-label">Confirmar Senha</label>
          <div>
            <input class="form-control check-input" type="password" formControlName="password_confirmation"
              placeholder="Confirmar Senha" />
          </div>
        </div>
      </form>
      <div class="d-flex justify-content-center align-items-center mt-5 gap-1">
        <input type="button" class="button button-green w-25" value="Salvar" (click)="submitPassword()">
        <input type="reset" class="button button-cancel w-25" value="Editar" (click)="habiliteEdition()">
      </div>
    </div>
  </div>
</div>